/**
* Double Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Double Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'double-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.splide--double-marquee' ).each( function( key, marquee ) {
        const splide = new Splide( marquee, {
          type: 'loop',
          pagination: false,
          arrows: false,
          autoWidth: true,
          gap: '12px',
          direction: $( marquee ).attr( 'data-direction' ),
          autoScroll: {
            speed: 0.5,
          },
        } );

        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'double-marquee', COMPONENT );
} )( app );
